var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b5i86nqara",
    d: "M0 0h27.263v27.263H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.053 4.053)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ppnmxrlx7b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5i86nqara"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.166 13.632A11.501 11.501 0 0 0 13.632 2.097 11.501 11.501 0 0 0 2.097 13.632a11.501 11.501 0 0 0 11.535 11.534c6.396 0 11.534-5.19 11.534-11.534m2.097 0c0 7.55-6.082 13.631-13.631 13.631C6.082 27.263 0 21.13 0 13.632 0 6.134 6.082 0 13.632 0c7.549 0 13.631 6.082 13.631 13.632",
    fill: "#AC9EE4",
    mask: "url(#ppnmxrlx7b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.224 23.947c-.28 0-.56-.108-.773-.323L9.9 19.02a1.116 1.116 0 0 1-.001-1.565 1.085 1.085 0 0 1 1.548 0l3.777 3.82 8.329-8.425a1.088 1.088 0 0 1 1.548 0 1.118 1.118 0 0 1 0 1.566l-9.103 9.208a1.087 1.087 0 0 1-.774.323",
    fill: "#4615D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfComplete);
export default __webpack_public_path__ + "static/media/af-complete.6fc7ce54828c47fbd031e1cc6e344769.svg";
export { ForwardRef as ReactComponent };